{
  "graphWindows": {
    "closeAll": "Закрыть все окна"
  },
  "advancedTQLFilter": {
    "title": "Расширенный TQL фильтр"
  },
  "matcherForm": {
    "literal": "Литерал",
    "fromList": "Из списка",
    "operator": "Оператор",
    "value": "Значение",
    "addGroup": "Добавить группу",
    "addCondition": "Добавить условие",
    "placeholders": {
      "value": "Значение",
      "selectValue": "Выберите значение",
      "selectValues": "Выберите значения",
      "ip": "IP адрес",
      "min": "Минимум",
      "max": "Максимум"
    }
  },
  "matcherTargets": {
    "attribute": {
      "label": "Атрибут",
      "errorMessage": "Атрибут не найден",
      "userAttributes": "Атрибуты пользователя"
    },
    "ciStatus": {
      "label": "Статус КЕ"
    },
    "hiStatus": {
      "label": "Статус ИЗ"
    },
    "user": {
      "login": "Логин"
    }
  },
  "conditions": {
    "and": "И",
    "or": "Или"
  },
  "tqlNode": "Узел TQL",
  "nodePanel": {
    "title": "CI",
    "connected": "Связано",
    "showAll": "Показать все",
    "hideAll": "Скрыть все",
    "type": "Тип",
    "hi": "Индикаторы здоровья",
    "name": "Название",
    "label": "Метка",
    "edit": "Редактировать",
    "editVariables": "Изменить переменные",
    "delete": "Удалить",
    "script": "Скрипт",
    "action": "Действие",
    "runScript": "Запустить скрипт",
    "runAction": "Запустить действие",
    "enrichment": "Выполнить обогащение",
    "enrichment-settings": {
      "title": "Настройки обогащения",
      "enrichAttributes": "Обогатить атрибуты",
      "enrichLinks": "Обогатить связи"
    },
    "showTargetAttributes": "Показать целевые атрибуты",
    "targetAttributes": "Целевые атрибуты",
    "parameters": "Параметры",
    "attributes": "Атрибуты",
    "selectedCis": "Выбранные КЕ",
    "currentValue": "Текущее значение",
    "bulkLinks": {
      "title": "Связать к одной КЕ",
      "target": "Целевая КЕ",
      "selectAllAvailable": "Выбрать все допустимые",
      "sourceType": "ТКЕ: {{type}}",
      "loading": "Проверяем связи по ТКЕ...",
      "notAllowedByTypes": "Связь недоступна для этой пары ТКЕ",
      "alreadyLinked": "Все допустимые типы связи уже созданы",
      "linkType": "Тип связи",
      "statusAllowed": "Доступно",
      "statusNotAllowed": "Недоступно",
      "statusExisting": "Уже есть",
      "statusChecking": "Проверка",
      "create": "Создать связи",
      "success": "Создано связей: {{count}}",
      "error": "Не удалось создать связи"
    }
  },
  "variablesDialog": {
    "title": "Переменные скрипта",
    "empty": "Нет переменных",
    "runScript": "Запустить"
  },
  "editVariablesDialog": {
    "title": "Редактор переменных",
    "empty": "Нет переменных"
  },
  "layout": {
    "import": "Импорт",
    "export": "Экспорт",
    "refresh": "Обновить",
    "refreshInterval": "Автообновление",
    "graph": "Граф",
    "graphViews": "Представления графа",
    "map": "Карта",
    "table": "Таблица",
    "monitoring": "Мониторинг",
    "activeHIs": "Активные ИЗ",
    "ciHealth": "Здоровье КЕ",
    "search": "Поиск",
    "savedSearch": "Сохраненные запросы",
    "reloadData": "Обновить данные",
    "savedSearchEmpty": "Нет сохраненных поисков",
    "empty": {
      "useSearch": "Воспользуйтесь поиском",
      "description": "Выполните новый поиск или откройте сохраненный запрос, чтобы загрузить граф и связанные представления."
    },
    "showOnGraph": "Показать на графе",
    "showOnMap": "Показать на карте",
    "viewingRelatedNodes": "Просмотр связанных узлов",
    "display": "Отобразить",
    "openConsole": "Открыть консоль"
  },
  "filters": {
    "clear": "Сбросить все",
    "connection": "Связь",
    "clone": "Клонировать ноду",
    "delete": "Удалить ноду",
    "allLinks": "Показывать все связи между КЕ",
    "version": "Версия",
    "selectCIType": "Выберите тип КЕ"
  },
  "ciHealth": {
    "registry": {
      "title": "Реестр КЕ",
      "description": "{{total}} КЕ из запроса · {{deviations}} с отклонениями за период"
    },
    "detail": {
      "typeAndHis": "{{type}} · {{count}} индикаторов",
      "outOfScope": "Вне выборки",
      "linksButton": "Ссылки",
      "links": "Ссылки",
      "linksLoadError": "Не удалось загрузить ссылки",
      "dashboards": "Дашборды",
      "dashboardsLoadError": "Не удалось загрузить дашборды",
      "dashboardNoFilter": "Без фильтра по КЕ",
      "noResources": "Ничего не настроено"
    },
    "columns": {
      "ci": "КЕ",
      "type": "Тип",
      "current": "Сейчас",
      "inStatus": "В статусе",
      "hisNotOk": "ИЗ не в норме",
      "worst": "Худший за период",
      "timeNotOk": "Время не в норме",
      "transitions": "Переключений"
    },
    "hiColumns": {
      "hi": "Индикатор здоровья",
      "type": "Тип",
      "current": "Сейчас",
      "inStatus": "В статусе",
      "worst": "Худший за период",
      "timeNotOk": "Время не в норме",
      "transitions": "Перекл.",
      "statusStrip": "Полоса состояний",
      "templateDeleted": "Шаблон удалён",
      "nodeId": "Узел TQL ID: {{id}}"
    },
    "segmentTooltip": {
      "start": "Начало",
      "end": "Конец",
      "ongoing": "В процессе",
      "duration": "Длительность"
    },
    "legend": {
      "notAttached": "Индикатор не был привязан к КЕ"
    },
    "hiStage": {
      "current": "Только этот индикатор",
      "depends": "С зависимостями",
      "selectedInterval": "Выбран интервал <strong>{{start}} → {{end}}</strong>",
      "noSelectedInterval": "Нет выбранного интервала",
      "ongoing": "продолжается",
      "viewSwitchHint": "Переключатель виден только у расчётных индикаторов с зависимостями",
      "dependsHint": "Сначала изменившиеся до выбранного перехода, ближайшие к нему сверху",
      "segments": {
        "status": "Статус",
        "start": "Начало",
        "end": "Конец",
        "clippedLeft": "Интервал начался до выбранного окна",
        "clippedRight": "Интервал продолжается после выбранного окна",
        "duration": "Длительность",
        "alerts": "Тревог",
        "reason": "Причина"
      }
    },
    "hiDepends": {
      "openCi": "Открыть КЕ: {{name}}",
      "openHi": "Открыть индикатор здоровья: {{name}}",
      "hi": "Индикатор",
      "current": "Сейчас",
      "toTransition": "К переходу",
      "referencePoint": "Точка отсчёта",
      "simultaneous": "Одновременно",
      "holdingSince": "Держится с {{date}}",
      "notAttachedAtMoment": "Не была привязана в этот момент",
      "alreadyReacted": "Родитель уже отреагировал",
      "accessDenied": "Нет доступа",
      "outOfScope": "Зависимость вне ваших прав",
      "shown_one": "Показана <strong>{{count}}</strong> зависимость из <strong>{{total}}</strong>",
      "shown_few": "Показаны <strong>{{count}}</strong> зависимости из <strong>{{total}}</strong>",
      "shown_many": "Показаны <strong>{{count}}</strong> зависимостей из <strong>{{total}}</strong>",
      "shown_other": "Показано <strong>{{count}}</strong> зависимостей из <strong>{{total}}</strong>",
      "limitNote": "Сначала одновременные, затем ближайшие прошедшие, затем без переходов, затем будущие"
    },
    "reason": {
      "title": "Причина",
      "causes": "Дерево причин",
      "impact": "Дерево влияния",
      "builtAt": "На {{at}}",
      "truncated": "неполное",
      "accessDenied": "Нет доступа",
      "accessDeniedCi": "КЕ: нет доступа",
      "accessDeniedHiType": "Тип индикатора здоровья: нет доступа",
      "noAccess": "Нет доступа",
      "causePath": "Ветка причины",
      "deadEnd": "Источник не прослеживается",
      "source": "Первоисточник",
      "repeated": "(показан выше)",
      "affected": "задет",
      "active": "активна",
      "closedAt": "закрыта {{at}}",
      "closeEvent": "Закрыть событие",
      "closeConfirm": "Закрыть тревогу «{{name}}»?",
      "closeConsequence": "Тревога будет отмечена как закрытая. Её история сохранится.",
      "closeWarning": "Ручное закрытие не устраняет причину тревоги. При новом срабатывании она может появиться снова.",
      "closeAttribution": "В записи о закрытии будет указана ваша учётная запись.",
      "forceCloseWarning": "Тревога закрывается автоматически. Закрываем принудительно",
      "alertClosed": "Тревога закрыта",
      "rootCause": "Первопричина",
      "intervalAlerts": "Тревоги интервала",
      "selectInterval": "Выберите интервал, и данные появятся",
      "otherAlerts_one": "Ещё {{count}} тревога",
      "otherAlerts_few": "Ещё {{count}} тревоги",
      "otherAlerts_many": "Ещё {{count}} тревог",
      "otherAlerts_other": "Ещё {{count}} тревог",
      "alertsLoadError": "Не удалось загрузить тревоги",
      "noAlerts": "Нет тревог",
      "analyze": "Разобрать",
      "ciType": "ТКЕ: {{label}} ({{name}})",
      "openCi": "Открыть КЕ",
      "triggeredTransition": "Вызвали переход",
      "beforeParent": "на {{duration}} раньше родителя",
      "afterTransition": "после перехода",
      "sameTimeAsParent": "одновременно с родителем",
      "moreDependencies_one": "ещё {{count}} зависимость",
      "moreDependencies_few": "ещё {{count}} зависимости",
      "moreDependencies_many": "ещё {{count}} зависимостей",
      "moreDependencies_other": "ещё {{count}} зависимостей",
      "noData": "Нет данных",
      "loadError": "Не удалось загрузить дерево причин",
      "evidence": {
        "notConfigured": "Источник медиаданных не настроен для этого индикатора",
        "showThumbnails": "Показать миниатюры",
        "hideThumbnails": "Скрыть миниатюры",
        "tolerance": "Допуск",
        "window": "Окно",
        "transition": "Переход",
        "interval": "Интервал",
        "unavailableNote": "Некоторые объекты недоступны. Остальные доказательства доступны для просмотра.",
        "loadMore": "Показать ещё",
        "title": "Доказательства",
        "empty": "За это время медиаданные не сохранились",
        "loadError": "Не удалось загрузить доказательства",
        "unavailable": "Объект недоступен",
        "nearest": "В момент перехода",
        "position": "{{index}} из {{total}}",
        "previous": "Предыдущее доказательство",
        "next": "Следующее доказательство",
        "download": "Скачать файл",
        "exitFullscreen": "Выйти из полноэкранного режима"
      }
    },
    "search": {
      "registry": "Поиск по КЕ",
      "ci": "Поиск по индикаторам здоровья и КЕ"
    }
  },
  "tqlList": {
    "columns": {
      "name": "Имя",
      "label": "Отображаемое имя"
    }
  },
  "filterDialog": {
    "title": "Сохраненный запрос",
    "label": "Отображаемое имя",
    "name": "Имя",
    "systemName": "Системное имя",
    "menu": "Меню",
    "tags": "Теги",
    "cit": "Типы КЕ",
    "openModal": "Открыть в модальном окне",
    "countCi": "Подсчитать КЕ",
    "rollback": "Сбросить",
    "clear": "Очистить",
    "fitView": "Центрировать",
    "noParamsMessage": "Граф выполнен без параметров"
  },
  "customNode": {
    "filtered": "Фильтр",
    "hidden": "Скрыт",
    "invalidTarget": "Нет доступных связей",
    "viewCis": "Посмотреть КЕ",
    "edit": "Редактировать",
    "rename": "Переименовать",
    "delete": "Удалить"
  },
  "nodeCisDialog": {
    "title": "КЕ выбранной ноды",
    "columns": {
      "id": "ID",
      "ciType": "Тип КЕ",
      "name": "Имя"
    }
  },
  "nodeRenameDialog": {
    "nodeAliasName": "Отображаемое имя узла",
    "aliasName": "Имя узла"
  },
  "nodeDialog": {
    "title": "КЕ",
    "type": "Тип",
    "composingCi": "Композирующий КЕ",
    "secretAttribute": {
      "placeholder": "Значение задано",
      "description": "оставьте пустым, чтобы не менять",
      "clear": "Очистить"
    },
    "fileComponent": {
      "upload": "Загрузить файл",
      "delete": "Удалить файл",
      "msg": {
        "saveSuccess": "Файл сохранён",
        "deleteSuccess": "Файл удалён"
      }
    }
  },
  "bulkNodeDialog": {
    "title": "Создание КЕ",
    "basicParameters": "Основные параметры",
    "tableTitle": "Атрибуты конфигурационной единицы",
    "tableDescription": "Задайте значения атрибутов для создаваемых КЕ",
    "hintTitle": "Подсказка",
    "hintDescription": "Добавьте атрибуты, которые будут использоваться для описания вашей КЕ.",
    "attributes": "Атрибуты",
    "rows": "Создаваемые КЕ",
    "addRow": "Добавить строку",
    "cloneRow": "Клонировать",
    "addRowDisabledNoAttributes": "Выберите атрибуты, чтобы добавить строку",
    "addAttributesPlaceholder": "Добавьте атрибуты",
    "addCIAttributesPlaceholder": "Добавьте атрибуты КЕ",
    "required": "обязательный",
    "noAttributes": "Выберите тип КЕ",
    "copyToAll": "Скопировать значение на все КЕ",
    "successSaveMsg": "КЕ созданы",
    "abortConfirmTitle": "Прервать создание?",
    "abortConfirmText": "Цикл создания будет остановлен. Уже созданные КЕ останутся сохранёнными.",
    "columns": {
      "status": "Статус"
    },
    "status": {
      "draft": "Черновик",
      "processing": "Создание",
      "success": "Создано",
      "error": "Ошибка"
    }
  },
  "overlayText": "Нажмите для редактирования",
  "connectionDialog": {
    "title": "Связь",
    "form": {
      "type": "Тип",
      "limitations": "Ограничения",
      "from": "От",
      "to": "До",
      "source": "Источник",
      "target": "Цель",
      "direction": "Направление",
      "limitationsDirection": "Направление ограничения"
    },
    "validation": {
      "from": "Только цифры",
      "to": "Только цифры и *"
    }
  },
  "nodeConflictDialog": {
    "title": "Детали разрешения конфликта CI",
    "cancel": "Отменить",
    "edit": "Редактировать",
    "merge": "Объединить",
    "currentChanges": "Текущие изменения",
    "result": "Результат",
    "attributes": "Атрибуты",
    "noAttributes": "Нет аттрибутов",
    "deleteCiList": "CI для удаления",
    "deleteLinkList": "Список связей для удаления",
    "createLinkList": "Список связей для создания"
  },
  "ciConflictDialog": {
    "title": "⚠️ Обнаружен конфликт при создании КЕ",
    "description": "Система обнаружила, что создаваемая КЕ дублирует уже существующие. Для поддержания целостности данных предлагается объединить информацию. Нажмите на дубликат, чтобы просмотреть его атрибуты.",
    "finalCI": "✅ Итоговая конфигурационная единица (Будет сохранена)",
    "deletedDuplicates": "🗑️ Удаляемые дубликаты (Будут удалены)",
    "name": "Имя",
    "type": "Тип",
    "id": "ID",
    "attributes": "Атрибуты",
    "attribute": "Атрибут",
    "value": "Значение",
    "reject": "Отклонить",
    "confirmMerge": "Подтвердить слияние",
    "loading": "Загрузка...",
    "expandDuplicates": "Развернуть дубликаты",
    "collapseDuplicates": "Свернуть дубликаты",
    "ci": "КЕ",
    "undefinedName": "Имя не назначено"
  },
  "nodeReferencesDialog": {
    "title": "Связанные узлы",
    "onGraph": "На графе",
    "willBeAdded": "Будет добавлен",
    "outgoingLinks": "Исходящие связи",
    "showExisting": "Показать существующие ноды и связи",
    "selectedSummary": "Выбрано узлов: {{nodes}} · связей: {{links}}"
  },
  "configurationDialog": {
    "title": "Конфигурация",
    "reloadButton": "Восстановить конфигурацию",
    "reloadButtonWarn": "Вы действительно хотите восстановить конфигурацию? Вся информация в running-config будет перезаписана!",
    "fetchHistory": "Загрузить историю",
    "history": "История",
    "revisions": "Ревизии",
    "value": "Значение",
    "historyLoaded": "История загружена",
    "historyDisabled": "Сохранение истории для этого атрибута не настроено. Доступно только текущее значение.",
    "historyStatusUnavailable": "Не удалось проверить настройку сохранения истории. Доступно только текущее значение.",
    "historyEmpty": "История изменений для этого атрибута пока не содержит записей.",
    "historyLoadError": "Не удалось загрузить историю изменений. Попробуйте повторить позже.",
    "attributeValueHistoryTitle": "История значения атрибута",
    "textView": "Текст",
    "formView": "Форма",
    "cmEditor": "Code Mirror",
    "rjsf": "RJSF"
  },
  "mapDialog": {
    "title": "Расположение CIT",
    "locationUndefined": "Не определено"
  },
  "settingsDialog": {
    "title": "Фильтр",
    "conditions": {
      "or": "ИЛИ",
      "and": "И"
    },
    "attribute": "Атрибут",
    "status": "Статус",
    "group": "Группа",
    "login": "Логин пользователя",
    "hi-status": "Статус ИЗ",
    "form": {
      "attribute": "Атрибут",
      "status": "Статус КЕ",
      "login": "Логин пользователя",
      "hi-status": "Статус ИЗ",
      "operator": "Оператор",
      "value": "Ввод значений",
      "valueVariables": "Выбор из переменных",
      "valueExecute": "Ввод значений при выполнении",
      "noOperator": "Выберите оператор",
      "includeInResult": "Добавлять в результат запроса",
      "invalidCondition": "Некорретное условие",
      "deprecatedFieldValues": "Значения полей устарели",
      "listItem": {
        "dialog": {
          "title": "Список элементов"
        }
      }
    }
  },
  "graphViews": {
    "actions": {
      "dragAndDropCompoundMode": "Группировка перетаскиванием",
      "convertToCompound": "Конвертировать в группу",
      "collapse": "Свернуть",
      "expand": "Развернуть",
      "collapseAll": "Свернуть все",
      "expandAll": "Развернуть все",
      "collapseRecursively": "Свернуть рекурсивно",
      "expandRecursively": "Развернуть рекурсивно",
      "collapseSelected": "Свернуть выбранные",
      "expandSelected": "Развернуть выбранные",
      "collapseSelectedRecursively": "Свернуть выбранные рекурсивно",
      "expandSelectedRecursively": "Развернуть выбранные рекурсивно",
      "groupSelected": "Сгруппировать выбранные",
      "ungroupSelected": "Разгруппировать выбранные",
      "ungroupAll": "Разгруппировать все",
      "group": "Сгруппировать",
      "ungroup": "Разгруппировать",
      "viewCI": "Сведения о КЕ",
      "remove": "Удалить",
      "removeUnavailable": "Удалить недоступные элементы"
    },
    "text": {
      "group": "Группа",
      "compoundNode": "Сгруппированный узел",
      "compoundEdge": "Сгруппированная связь",
      "nodes": "Узлы",
      "edges": "Связи",
      "unavailableNode": "Узел отсутствует в выборке TQL запроса",
      "unavailableEdge": "Связь отсутствует в выборке TQL запроса"
    }
  },
  "graphView": {
    "panel": {
      "chrRecordButton": "Запись",
      "chrRecord": "Запись запроса на изменение",
      "addNodeMode": "Добавить CIT",
      "drawLinkMode": "Режим создания связей",
      "saveGraph": "Сохранить граф",
      "selectActiveCis": "Выбрать активные КЕ"
    },
    "filter": {
      "cits": "Фильтр по ТКЕ",
      "nodes": "Фильтр по узлам TQL",
      "his": "Фильтр по ИЗ",
      "crs": "Фильтр по ЗИ",
      "graphScheme": {
        "schema": "Схема",
        "monitoring": "Мониторинг"
      },
      "graphLayout": "Компоновка графа",
      "zoomClusters": "Кластеры при масштабе"
    }
  },
  "tqlGraphView": {
    "title": "Представления графа",
    "settings": {
      "loadFailed": "Не удалось применить сохранённое представление",
      "label": "Отображаемое имя",
      "name": "Имя",
      "displayOrder": "Порядок отображения",
      "savedViews": "Сохраненные представления",
      "deletedView": "Удаленное представление"
    }
  },
  "tableView": {
    "settings": "Настройки отображения",
    "settingsAttribute": {
      "display": "Настройки атрибутов",
      "groupByCIT": "Группировать по типу КЕ",
      "displayInTable": "Отображать в таблице",
      "form": {
        "attributes": "Отображать атрибуты"
      }
    },
    "render": "Табличное представление",
    "exportType": {
      "linear": "Без группировки",
      "group": "С группировкой"
    },
    "columns": {
      "name": "Название",
      "ciType": "Тип КЕ"
    },
    "report": {
      "dataNotReceived": "данные не получены",
      "columns": "Колонки отчёта",
      "metrics": "Метрики",
      "documents": "Документы",
      "groups": "Группы подстрок",
      "addColumn": "Добавить колонку",
      "addGroup": "Добавить группу",
      "source": "Источник",
      "label": "Название колонки",
      "query": "Запрос",
      "index": "Индекс",
      "joinKind": {
        "field": "Поле КЕ",
        "attribute": "Атрибут КЕ",
        "none": "Без связи: одно значение на все КЕ",
        "key": "По ключу связи"
      },
      "ciKey": "Поле или атрибут КЕ",
      "sourceKey": "Метка или поле документа",
      "aggregation": "Несколько значений на ключ",
      "total": "Итог на строке КЕ",
      "totalOff": "Выключен",
      "valuePath": "Путь до значения в бакете",
      "groupLabel": "Название группы",
      "subrowKeys": "Метки ключа подстроки",
      "titleKey": "Метка подписи подстроки",
      "labelHint": "Период и единицу измерения укажите в названии колонки",
      "queryHint": "Ссылка на узел TQL подставляет список КЕ отчёта",
      "joinHint": "Части ключа собираются со своей КЕ и с её предков по композиции",
      "aggregations": {
        "sum": "Сумма",
        "avg": "Среднее",
        "min": "Минимум",
        "max": "Максимум",
        "count": "Количество"
      },
      "columnTitle": "Колонка отчёта",
      "groupTitle": "Группа подстрок",
      "joinKindLabel": "Со стороны КЕ",
      "group": "Группа подстрок",
      "noGroup": "Нет: колонка строки КЕ",
      "subrowKeysHint": "Метки метрики или поля документа, образующие ключ подстроки",
      "withoutJoin": "без связи",
      "notAggregatable": "группировка недоступна",
      "ciFields": "Поля КЕ",
      "ciAttributes": "Атрибуты ТКЕ узла",
      "noJoinHint": "Значение запроса попадёт во все КЕ узла",
      "groupDisabled": "Без связи подстроки строить не по чему",
      "joinKey": "Ключ связи",
      "joinKeyHint": "Значение источника попадёт в ту строку, у которой совпали все части",
      "addJoinPart": "Добавить часть ключа",
      "ownNode": "эта КЕ",
      "ambiguousJoin": "ключ связи не уникален",
      "joinNode": "Узел"
    },
    "unsavedChanges": "Есть несохранённые изменения",
    "saveSettings": "Сохранить настройку"
  },
  "ciImportDialog": {
    "title": "Импорт",
    "importType": "Тип импорта",
    "importCi": "КЕ",
    "importGraph": "Граф",
    "type": "Тип",
    "file": "Файл",
    "downloadTemplate": "Скачать шаблон",
    "chooseFile": "Выберите файл",
    "import": "Импортировать",
    "conflictData": {
      "ci_name": "Название КЕ",
      "ci_type": "Тип КЕ"
    },
    "message": {
      "importSuccess": "Импортировано"
    }
  },
  "ciExportDialog": {
    "title": "Экспорт",
    "CSV": "CSV",
    "JSON": "JSON",
    "cis": "КЕ",
    "ciType": "Тип КЕ",
    "tqlNode": "TQL узел",
    "attributes": "Атрибуты",
    "nodeAttributes": "Атрибуты узла",
    "nodesAttributes": "Атрибуты узлов"
  },
  "ciImportResultDialog": {
    "title": "Результат импорта",
    "cisTotal": "Импортировано CI",
    "linksTotal": "Импортировано связей"
  },
  "inputDialog": {
    "title": "Переменные запроса"
  },
  "actions": {
    "startRec": "Начать запись",
    "stopRec": "Остановить",
    "regActive": "Идет запись"
  },
  "hiHistoryView": {
    "prometheus": "Prometheus",
    "vm": "Агент обработки правил",
    "affects": "Влияет на",
    "depends": "Зависит от",
    "dialog": {
      "hi": "Индикатор здоровья",
      "title": "Здоровье КЕ за период",
      "ci": "Конфигурационная единица",
      "finishedAt": "Завершено",
      "hit": "Тип",
      "duration": "Длительность",
      "severity": "Критичность",
      "startedAt": "Создан"
    }
  }
}